// import handleErrorAPI from "../../utils/handleErrorAPI";
import apiClient from "../apiClient";

export const addAdmin = async (adminData) => {
  try {
    const response = await apiClient.post("users/createAdmin", adminData);
    return response?.data;
  } catch (error) {
    throw error;
  }
};
export const updateAdmin = async (adminData) => {
  try {
    const response = await apiClient.put("users/updateAdmin", adminData);
    return {
      status: true,
      data: response?.data,
    };
  } catch (error) {
    throw error;
  }
};
export const deleteAdmin = async ({ id }) => {
  try {
    const response = await apiClient.delete(`users/deleteAdmin/${id}`);
    return {
      status: true,
      data: response?.data,
    };
  } catch (error) {
    throw error;
  }
};
export const getAllAdminsAPI = async () => {
  try {
    const usersData = await apiClient.get("users/getAdmins");
    return usersData?.data?.users ?? [];
  } catch (error) {
    throw error;
  }
};
